export const STATUS_COLORS = {
  "Not Started": { bg: "#f5f5f5", color: "#616161", dot: "#9e9e9e" },
  "Open":        { bg: "#fff3e0", color: "#e65100", dot: "#ff6f00" },
  "In Progress": { bg: "#e3f2fd", color: "#1565c0", dot: "#1e88e5" },
  "Completed":   { bg: "#e8f5e9", color: "#2e7d32", dot: "#43a047" },
  "Cancelled":   { bg: "#fce4ec", color: "#c2185b", dot: "#e91e63" },
  "On Hold":     { bg: "#fff8e1", color: "#f57f17", dot: "#fbc02d" },
};
